var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accessPointToLabelMap[_vm.level])?_c('span',{staticClass:"label label--access-point-badge",class:{'label--subheading': _vm.limitWidth}},[_vm._v("\n  "+_vm._s(_vm.accessPointToLabelMap[_vm.level])+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }